import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'
import router from '@/router';
import { getCookie, removeCookie } from '../assets/js/cookie';
const crypto = require("crypto");


let isShow = false

// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// create an axios instance
// console.log('process.env.VUE_APP_BASE_API', process.env, process.env.NODE_ENV, process.env.VUE_APP_API_URL)
const service = axios.create({
  baseURL: window.location.origin + process.env.VUE_APP_API_URL, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 120000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    const timestamp = new Date().getTime()
    let signStr = sign(timestamp.toString(), getUuid())
    
    if (getCookie()) {
      config.headers['Token'] = getCookie()
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

function getUuid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}

function sign (timestampStr, uuid) {
  // console.log('签名：', timestampStr, uuid)
  let secret = "l8c2scudgvf3aavrkuohep4r6a16nj7s"
  let stringToSign = timestampStr + uuid;
  // console.log('sign', crypto)
  let mac = crypto.createHmac("sha256", secret);
  mac.update(stringToSign);
  let signData = mac.digest();
  let signStr = Buffer.from(signData).toString("base64");
  let stringToSignStr = Buffer.from(stringToSign).toString("base64");
  return signStr + stringToSignStr;
}



function showLogout() {
  removeCookie(false)
  ElMessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    router.replace({ path: '/login' })
  }).catch(() => {})
}

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = res.data.message || '接口异常'
    if (code === 401) {
      if (!isShow) {
        showLogout()
        isShow = true
        setTimeout(()=>{
          isShow = false
        }, 1500)
      }
    } else if (code === 500) {
      ElMessage.error(msg)
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      ElMessage.error(msg)
      return Promise.reject('error')
    } else {
      return Promise.resolve(res.data)
    }
  },
  error => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service
